'use client';

// 空页面类型枚举 影响页面图片展示
export enum EEmptyPageType {
    // 无数据
    NO_DATA = 'no-data',
    // 错误
    ERROR = 'error',
    // 仅展示文案
    ONLY_TEXT = 'only-text',
}

interface IEmptyPlaceholderProps {
    onClick?: () => void;
    type?: EEmptyPageType;
    btnInfo?: string;
    tips: string;
}

/**
 * 空状态占位组件
 * @param onClick 点击事件
 * @param tips 提示语
 * @param btnInfo 按钮文字 为空则不显示按钮
 * @param type 类型(展示图片) error 错误 | no-data 无数据 | only-text 仅展示文案
 * @returns
 */
export default function EmptyPlaceholder(props: IEmptyPlaceholderProps) {
    const { onClick, tips, btnInfo = '' } = props;

    return (
        <div className='flex h-[90vh] flex-col items-center justify-center'>
            <div className='flex flex-col items-center justify-center'>
                <div className='w-[215px] text-center text-[14px] leading-[20px] text-[#888]'>{tips}</div>
                {btnInfo && (
                    <div className='mt-[24px] flex justify-center'>
                        <div
                            className='h-[40px] w-[180px] rounded-full text-center font-poppins-semibold text-[14px] font-semibold leading-[40px] text-white [background:var(--primary-button-gradient)]'
                            onClick={onClick}
                        >
                            {btnInfo}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
